import { Navigate, Outlet } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { useState, useEffect } from "react";

const ProtectedRoute = ({ allowedRoles }) => {
  const { userDetails } = useApp();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    if (userDetails !== undefined) {
      setIsChecking(false);
    }
  }, [userDetails]);

  if (isChecking) {
    return <></>;
  }

  if (!userDetails) {
    return <Navigate to="/" replace />;
  }

  return allowedRoles.includes(userDetails.role) ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;

